import { getSessionToken, getSessionSocketId } from '../store/slices/sessionSlice'
import axios from 'axios'
import qs from 'qs'

axios.defaults.paramsSerializer = params => qs.stringify(params)

export class Api {
    constructor(baseUrl, appBuildVersion, deviceType) {
        this.getState = null
        this.baseUrl = baseUrl
        this.appBuildVersion = appBuildVersion
        this.deviceType = deviceType
        this.menu = this._get('v2/page/layout/menu')
        this.getSession = this._get('v2/session-new')
        this.getSessionSettings = this._get('v2/session-new/settings')
        this.products = this._get('v2/catalog')
        this.filters = this._get('v2/catalog/filters')
        this.catalogSearch = this._get('v2/catalog/search')
        this.product = this._get('product')
        this.productBack = this._get('v2/product')
        this.newProductBack = this._get('v2/product/model')
        this.productCollections = this._get('v2/product/model/collections')
        this.productFromCollections = this._get('v2/product/model/collections/paginate')
        this.productLooks = this._get('v2/product/model/look')
        this.productShops = this._get('v2/product/model/shops')
        this.countriesOfDelivery = this._get('v2/delivery/countries')
        this.currencyRates = this._get('back/currency')
        this.login = this._post('v2/auth/login')
        this.pushToken = this._post('v2/push-tokens/put')
        this.deletePushToken = this._post('v2/push-tokens/delete')
        this.logout = this._post('v2/auth/logout')
        this.removeProfile = this._post('v2/auth/remove')
        this.sendSmsCode = this._post('v2/auth/sms')
        this.shops = this._get('back/shops')
        this.validateCheckoutPersonalData = this._post('back/order/personal-info')
        this.validateCheckoutDelivery = this._post('back/order/delivery')
        this.checkout = this._post('back/order')
        this.getLastOrder = this._get('v2/order/success')
        this.getErrorPaymentInfo = this._get('v2/service/payment/info')
        this.emailVerify = this._post('v2/client/email-verify')
        this.getRedirectInfo = this._get('v2/service/payment/redirect')
        this.userProfileUpdate = this._post('v2/client/profile')
        this.profileSubscriptions = this._get('v2/client/profile/subscriptions')
        this.addressDelete = this._post('back/profile/address/delete')
        this.userOrders = this._get('v2/client/order')
        this.userOrder = this._get('v2/client/order/show')
        this.userDiscount = this._get('v2/client/profile/discount')
        this.userRefunds = this._get('v2/client/refund')
        this.returnableProducts = this._get('v2/client/order/products')
        this.sendRefund = this._post('v2/order/refund')
        this.createFavoriteBrand = this._post('v2/favorite-brands/create')
        this.deleteFavoriteBrand = this._post('v2/favorite-brands/delete')
        this.refundInfo = this._get('v2/order/refund/hash')
        this.pages = this._get('back/pages')
        this.news = this._get('v2/articles')
        this.specialOffers = this._get('v2/special-offers')
        this.promocode = this._post('v2/order/promo-code/apply')
        this.newSearch = this._get('search/autocomplete')
        this.search = this._get('back/search')
        this.searchPage = this._get('search')
        this.barcode = this._get('barcode')
        this.subscribeByEmail = this._post('back/subscribe/email')
        this.certificateApply = this._post('v2/order/certificate/apply')
        this.certificateRemove = this._post('v2/order/certificate/remove')
        this.allCertificateRemove = this._post('v2/order/certificate/remove/all')
        this.brands = this._get('v2/brands')
        this.look = this._get('back/looks')
        this.subscriptions = this._get('v2/subscription-popups')
        this.phoneValidate = this._post('v2/validate/phone')
        this.emailValidate = this._post('v2/validate/email')
        this.subscriptionsSubscribe = this._post('v2/subscription-popups/subscribe')
        this.categoryTreeBySlug = this._get('v2/page/layout')
        this.categoryTreeRoots = this._get('v2/page/layout/root')
        this.categoryTree = this._get('v2/page/catalog')
        this.newCheckout = this._post('v2/order/checkout')
        this.shopsNew = this._get('v2/order/shops')
        this.timeSlots = this._post('v2/delivery/slots')
        this.wishlist = this._get('v2/session-new/favorites/new')
        this.addToWishlist = this._post('v2/session-new/favorites/new/create')
        this.removeFromWishlist = this._post('v2/session-new/favorites/new/delete')
        this.updateWishlist = this._post('v2/session-new/favorites/new/update')
        this.history = this._get('v2/session-new/history')
        this.addProductToViewed = this._post('v2/session-new/history/put')
        this.cart = this._get('v2/session-new/cart/dispatch')
        this.asyncCart = this._get('v2/session-new/cart')
        this.addToCart = this._post('v2/session-new/cart/put')
        this.removeFromCart = this._post('v2/session-new/cart/delete')
        this.updateCart = this._post('v2/session-new/cart/update')
        this.addLookToCart = this._post('v2/session-new/cart/put-batch')
        this.deliveryInfo = this._get('v2/session-new/cart/delivery-info')
        this.feedback = this._get('v2/feedback')
        this.marketProducts = this._get('v2/product/model/list')
        this.postFeedback = this._post('v2/feedback/create')
        this.getRegions = this._get('v2/regions')
        this.setRegion = this._post('v2/regions/set-region')
    }

    setStateReceivingFunction(f) {
        this.getState = f
    }

    fullUrl = (url, inlineSlug) => {
        return inlineSlug ? `${this.baseUrl}/${url}/${inlineSlug}` : `${this.baseUrl}/${url}`
    }

    _get(url) {
        return (query = {}) => {
            const token = getSessionToken(this.getState()) ?? null
            const socketId = getSessionSocketId(this.getState()) ?? null
            const { cancelToken = axios.CancelToken.source().token, inlineSlug = '', ...params } = query

            let headers = { 'Device-Type': this.deviceType }

            if (token) {
                headers = { ...headers, Authorization: `Bearer ${token}` }
            }
            if (this.appBuildVersion) {
                headers = { ...headers, 'X-Client-Version': this.appBuildVersion }
            }
            if (socketId) {
                headers = { ...headers, 'X-Socket-ID': socketId }
            }

            return axios
                .get(this.fullUrl(url, inlineSlug), {
                    cancelToken,
                    params,
                    headers,
                })
                .then(response => response.data)
                .catch(error => {
                    const config = error.response?.config || {}
                    const { method, url, params } = config
                    return {
                        result: 'error',
                        statusCode: error.response?.status,
                        config: { method, url, params },
                        data: error.response?.data,
                        message: error.message
                    }
                })
        }
    }

    _post(url) {
        return (query = {}) => {
            const token = getSessionToken(this.getState()) ?? null
            const socketId = getSessionSocketId(this.getState()) ?? null

            const { cancelToken = axios.CancelToken.source().token, params, ...data } = query
            let headers = { 'Device-Type': this.deviceType }
            if (token) {
                headers = { ...headers, Authorization: `Bearer ${token}` }
            }
            if (this.appBuildVersion) {
                headers = { ...headers, 'X-Client-Version': this.appBuildVersion }
            }
            if (socketId) {
                headers = { ...headers, 'X-Socket-ID': `${socketId}` }
            }

            return axios
                .post(this.fullUrl(url), data, {
                    cancelToken,
                    headers,
                    params,
                })
                .then(response => response.data)
                .catch(error => ({
                    result: 'error',
                    statusCode: error.response?.status,
                    ...error.response?.data,
                    message: error.response?.data?.message || error.message
                }))
        }
    }

    _put(url) {
        return (query = {}) => {
            const token = getSessionToken(this.getState()) ?? null
            const { cancelToken = axios.CancelToken.source().token, params, ...data } = query
            let headers = {}
            if (token) {
                headers = { Authorization: `Bearer ${token}` }
            }
            if (this.appBuildVersion) {
                headers = { ...headers, 'X-Client-Version': this.appBuildVersion }
            }

            return axios
                .put(this.fullUrl(url), data, {
                    cancelToken,
                    headers,
                    params,
                })
                .then(response => response.data)
                .catch(error => ({
                    result: 'error',
                    statusCode: error.response?.status,
                    ...error.response?.data,
                    message: error.response?.data?.message || error.message
                }))
        }
    }

    _delete(url) {
        return (query = {}) => {
            const token = getSessionToken(this.getState()) ?? null
            const { cancelToken = axios.CancelToken.source().token, ...data } = query
            let headers = {}
            if (token) {
                headers = { Authorization: `Bearer ${token}` }
            }
            if (this.appBuildVersion) {
                headers = { ...headers, 'X-Client-Version': this.appBuildVersion }
            }

            return axios
                .delete(`${this.fullUrl(url)}`, data, {
                    cancelToken,
                    headers,
                })
                .then(response => response.data)
                .catch(error => ({
                    result: 'error',
                    statusCode: error.response?.status,
                    ...error.response?.data,
                    message: error.response?.data?.message || error.message
                }))
        }
    }
}
